import { Pipe, PipeTransform } from '@angular/core';
import { CONFIG } from '../store/reducer/config.reducer';

@Pipe({
    name: 'basketCount',
    standalone: false
})
export class BasketCountPipe implements PipeTransform {
  transform(basket: any, config: CONFIG, filter?) {
    let count = 0;
    let partsCount = 0;
    if (!filter) {
      if (basket[config.uid]) {
        Object.keys(basket[config.uid]).map((page) => {
          if (basket[config.uid][page]) {
            Object.keys(basket[config.uid][page]).map((part) => {
              count += basket[config.uid][page][part]['count'];
              partsCount++;
            });
          }
        });
      }
    } else {
      if (basket[config.uid]) {
        if (basket[config.uid][filter]) {
          Object.keys(basket[config.uid][filter]).map((part) => {
            count += basket[config.uid][filter][part]['count'];
            partsCount++;
          });
        }
      }
    }

    if (partsCount) return `${count} (${partsCount})`;

    return count;
  }
}
